import { createEnv } from '@t3-oss/env-nextjs';

import { nextJsEnvSchema } from './env/nextJsEnvSchema';

export const env = createEnv(nextJsEnvSchema);
